import React, { useState, useEffect, useContext } from 'react'
import useToastContext from 'hooks/useToastContext'
import { useForm } from 'react-hook-form'
import { apiPost, apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/pathObj'
import { useTranslation } from 'react-i18next'
import OInputField from 'components/reusable/OInputField'
import formValidation from 'utils/formValidation'
import { useNavigate } from 'react-router-dom'
import AuthContext from 'context/AuthContext'
import Select from 'react-select'
import ErrorMessage from 'components/ErrorMessage'
import OTextArea from 'components/reusable/OTextArea'
import helpers from 'utils/helpers'

const AddNotification = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true
  })
  const notification = useToastContext()
  const [HRList, setHRList] = useState([])
  const [accountList, setAccountList] = useState([])
  const [referenceLink, setReferenceLink] = useState([])
  const [rememberMe, setRememberMe] = useState(false)
  const [referenceLinkAccountant, setReferenceLinkAccountant] = useState([])
  const [rememberMeAccountant, setRememberMeAccountant] = useState(false)
  const [HRError, setHRError] = useState(false)
  const [companyError, setCompanyError] = useState(false)
  const handleRememberMe = e => {
    setRememberMe(e.target.checked)
  }
  const handleRememberMeAccountant = e => {
    setRememberMeAccountant(e.target.checked)
  }
  const { updatePageName, user } = useContext(AuthContext)
  const [companyData] = useState(user?._id)

  const onSubmit = async data => {
    try {
      if (
        !rememberMe &&
        !rememberMeAccountant &&
        referenceLink.length == 0 &&
        referenceLinkAccountant.length == 0
      ) {
        setHRError(true)
        setCompanyError(true)
        return
      }
      let link = []
      if (referenceLink.length > 0) {
        link = referenceLink?.map(item => item?.value)
        setHRError(false)
        setCompanyError(false)
      }
      let linkAccount = []
      if (referenceLinkAccountant.length > 0) {
        linkAccount = referenceLinkAccountant?.map(item => item?.value)
        setHRError(false)
        setCompanyError(false)
      }
      let HRData = ''
      if (rememberMe) {
        HRData = 'allHRs'
      } else if (referenceLink.length > 0) {
        HRData = 'specificHR'
      }

      let accountantData = ''
      if (rememberMeAccountant) {
        accountantData = 'allAccountants'
      } else if (referenceLinkAccountant.length > 0) {
        accountantData = 'specificAccountant'
      }
      const payload = {
        title: data?.title,
        description: data?.description,
        sendToHR: HRData,
        hrs: link,
        sendToACC: accountantData,
        accountants: linkAccount,
        companyID: companyData
      }
      const res = await apiPost(apiPath.notificationAdd, payload)
      if (res?.data?.success) {
        navigate('/notification_manager')
        notification.success(res.data?.message)
      } else {
        notification.error(res?.data?.message)
      }
    } catch (err) {
      console.log('err:', err)
    }
  }

  useEffect(() => {
    updatePageName(t('ADD_NOTIFICATION'))
  }, [])

  const getHRList = async () => {
    try {
      const res = await apiGet(apiPath.allHR, {})
      setHRList(res?.data?.results)
    } catch (error) {
      console.log('error:', error)
    }
  }
  const referenceLinkOptions = HRList?.map(item => {
    return { label: item?.name, value: item?._id }
  })

  const getAccountantList = async () => {
    try {
      const res = await apiGet(apiPath.allAccountant, {})
      setAccountList(res?.data?.results)
    } catch (error) {
      console.log('error:', error)
    }
  }
  const referenceLinkOptionsAccountant = accountList?.map(item => {
    return { label: item?.name, value: item?._id }
  })

  useEffect(() => {
    getAccountantList()
  }, [])

  useEffect(() => {
    getHRList()
  }, [])

  const mainFunction = (value, e1, e2) => {
    if (value) {
      setCompanyError(false)
      setHRError(false)
    } else if (!e1 && e2.length == 0) {
      setCompanyError(true)
      setHRError(true)
    }
  }

  const onError = () => {
    if (!rememberMe && !rememberMeAccountant) {
      setHRError(true)
      setCompanyError(true)
    }
  }

  const getControlStyles = (baseStyles, state) => ({
    ...baseStyles,
    padding: '9px 4px',
    borderRadius: '0.5rem',
    border: '2px solid rgb(223 223 223)'
  })

  return (
    <>
      <div className='relative p-6 flex-auto'>
        <div className='grid sm:grid-cols-1 md:grid-cols-3'>
          <div className='px-2 col-span-1'>
            <OInputField
              wrapperClassName='relative z-0 mb-6 w-full group'
              name='title'
              inputLabel={
                <>
                  {t('TITLE')}
                  <span className='text-red-500'>*</span>
                </>
              }
              type='text'
              autoFocus
              register={register('title', formValidation['title'])}
              errors={errors}
            />
          </div>
          <div className='px-2 col-span-1.5'>
            <Select
              isMulti
              styles={{
                control: getControlStyles
              }}
              name='referenceLink'
              isDisabled={rememberMe}
              options={referenceLinkOptions}
              placeholder='Select HR'
              className='basic-multi-select'
              classNamePrefix='select'
              value={referenceLink}
              onChange={item => {
                setReferenceLink(item)
                mainFunction(
                  item.length > 0,
                  rememberMeAccountant,
                  referenceLinkAccountant
                )
              }}
            />
            {helpers.andCondition(
              HRError,
              <ErrorMessage message='Please select HR.' />
            )}
          </div>
          <div className='px-2 col-span-0.5'>
            <h6>Send to</h6>
            <div className='flex items-center h-5 mt-2'>
              <div>
                <input
                  id='remember'
                  type='checkbox'
                  disabled={referenceLink.length > 0}
                  checked={helpers.ternaryCondition(rememberMe, true, false)}
                  className='w-4 h-4 bg-gray-50 rounded border border-[#DFDFDF]  focus:ring-3 focus:ring-[#DFDFDF] dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-[#DFDFDF] dark:ring-offset-gray-800'
                  onChange={e => {
                    handleRememberMe(e)
                    mainFunction(
                      e.target.checked,
                      rememberMeAccountant,
                      referenceLinkAccountant
                    )
                  }}
                />
              </div>
              <label
                htmlFor='remember'
                className='ml-2 text-sm text-black dark:text-gray-300'
              >
                All HRs
              </label>
            </div>
          </div>
          <div className='px-2 col-span-1.5'>
            <Select
              isMulti
              styles={{
                control: getControlStyles
              }}
              name='referenceLink'
              isDisabled={rememberMeAccountant}
              options={referenceLinkOptionsAccountant}
              placeholder='Select accountant'
              className='basic-multi-select'
              classNamePrefix='select'
              value={referenceLinkAccountant}
              onChange={item => {
                setReferenceLinkAccountant(item)
                mainFunction(
                  item.length > 0,
                  rememberMeAccountant,
                  referenceLink
                )
              }}
            />
            {helpers.andCondition(
              companyError,
              <ErrorMessage message='please select accountant.' />
            )}
          </div>
          <div className='px-2 col-span-0.5'>
            <h6>Send to</h6>
            <div className='flex items-center h-5 mt-2'>
              <div>
                <input
                  id='remember'
                  type='checkbox'
                  disabled={referenceLinkAccountant.length > 0}
                  checked={helpers.ternaryCondition(
                    rememberMeAccountant,
                    true,
                    false
                  )}
                  className='w-4 h-4 bg-gray-50 rounded border border-[#DFDFDF]  focus:ring-3 focus:ring-[#DFDFDF] dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-[#DFDFDF] dark:ring-offset-gray-800'
                  onChange={e => {
                    handleRememberMeAccountant(e)
                    mainFunction(e.target.checked, rememberMe, referenceLink)
                  }}
                />
              </div>
              <label
                htmlFor='remember'
                className='ml-2 text-sm text-black dark:text-gray-300'
              >
                All Accountants
              </label>
            </div>
          </div>
          <div className='px-2 col-span-3 mt-5'>
            <OTextArea
              wrapperClassName='relative z-0 w-full group'
              name='description'
              maxLength={300}
              inputLabel={
                <>
                  {t('DESCRIPTION')}
                  <span className='text-red-500'>*</span>
                </>
              }
              type='textarea'
              register={register('description', formValidation['description'])}
              errors={errors}
            />
          </div>
        </div>
      </div>
      <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
        <button
          className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
          type='button'
          onClick={() => navigate('/notification_manager')}
        >
          {t('O_BACK')}
        </button>

        <button
          className='bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'
          type='submit'
          onClick={handleSubmit(onSubmit, onError)}
        >
          {t('O_ADD')}
        </button>
      </div>
    </>
  )
}

export default AddNotification
